import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { gbp } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useWishlist } from "@/context/WishlistContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();
  const { has, toggle } = useWishlist();
  const onSale = !!product.sale_price;
  const wished = has(product.id);

  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group relative flex flex-col bg-card border border-border hover:border-primary transition-colors duration-300 animate-fade-up"
      style={{ animationDelay: `${(index % 8) * 60}ms` }}
    >
      <Link to={`/product/${product.slug}`} className="relative block overflow-hidden aspect-square bg-secondary">
        <img
          src={product.images?.[0]}
          alt={product.name}
          loading="lazy"
          className="zoom-img h-full w-full object-cover"
        />
        <div className="absolute left-0 top-0 flex flex-col gap-1 p-2">
          {product.is_new && (
            <span className="bg-accent px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-accent-foreground">New</span>
          )}
          {onSale && (
            <span className="bg-destructive px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">Sale</span>
          )}
        </div>
        <button
          data-testid={`wishlist-toggle-${product.slug}`}
          onClick={(e) => { e.preventDefault(); toggle(product); }}
          className="absolute right-2 top-2 grid h-9 w-9 place-items-center bg-background/70 backdrop-blur-sm text-foreground/80 hover:text-accent transition-colors"
          aria-label="Add to wishlist"
        >
          <Heart className={`h-4 w-4 ${wished ? "fill-accent text-accent" : ""}`} />
        </button>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <span className="overline mb-1">{product.brand}</span>
        <Link to={`/product/${product.slug}`} className="mb-2 font-display text-base font-medium leading-snug hover:text-accent transition-colors line-clamp-2">
          {product.name}
        </Link>
        <div className="mb-3 flex items-center gap-1 text-muted-foreground">
          <Star className="h-3.5 w-3.5 fill-accent text-accent" />
          <span className="text-xs">{product.rating} ({product.review_count})</span>
        </div>
        <div className="mt-auto flex items-end justify-between">
          <div className="flex items-baseline gap-2">
            <span className="font-display text-lg font-semibold text-foreground">{gbp(onSale ? product.sale_price : product.price)}</span>
            {onSale && <span className="text-sm text-muted-foreground line-through">{gbp(product.price)}</span>}
          </div>
        </div>
        <button
          data-testid={`add-to-cart-${product.slug}`}
          onClick={() => addItem(product)}
          className="mt-3 w-full bg-primary py-2.5 text-xs font-bold uppercase tracking-widest text-primary-foreground transition-[background-color,filter] hover:brightness-125"
        >
          Add to Basket
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
